import { createContext, useContext } from 'react';
import type { PartnerSlug } from '../../../../shared/types/partnerships';

export const PARTNER_CONFIG: Record<PartnerSlug, {
  name: string;
  color: string;
  bgClass: string;
  textClass: string;
  borderClass: string;
  badgeClass: string;
}> = {
  tiktok: {
    name: 'TikTok',
    color: '#0066FF',
    bgClass: 'bg-blue-600',
    textClass: 'text-blue-600',
    borderClass: 'border-blue-600',
    badgeClass: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
  },
  google: {
    name: 'Google',
    color: '#DC2626',
    bgClass: 'bg-red-600',
    textClass: 'text-red-600',
    borderClass: 'border-red-600',
    badgeClass: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
  },
  meta: {
    name: 'Meta',
    color: '#9333EA',
    bgClass: 'bg-purple-600',
    textClass: 'text-purple-600',
    borderClass: 'border-purple-600',
    badgeClass: 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300',
  },
};

const PartnerThemeContext = createContext<PartnerSlug>('tiktok');

export function PartnerThemeProvider({ slug, children }: { slug: PartnerSlug; children: React.ReactNode }) {
  return <PartnerThemeContext.Provider value={slug}>{children}</PartnerThemeContext.Provider>;
}

export function usePartnerTheme() {
  const slug = useContext(PartnerThemeContext);
  return PARTNER_CONFIG[slug];
}
